export const updateStructuredHeadingDataObject = (component, newTag) => {
  if (newTag) {
    const data = {
      ...component.data,
      tagName: newTag
    };
    return {
      ...component,
      data
    };
  }
  return component;
};
//# sourceMappingURL=update-structured-heading-data-object.js.map